import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LoadJquery from "../helper/LoadJquery";



const Carousal = () => {
    useEffect(() => {
        // Ensure Swiper is available globally
        if (window.Swiper) {
            new window.Swiper('.mySwiper-banner-one', {
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 1,
                spaceBetween: 0,
                // Add more Swiper options as needed
            });
        } else {
            console.warn('Swiper is not loaded.');
        }
    }, []);

    return(
        <>
         <LoadJquery />
         {/* tmp banner area start */}
      <div className="tmp-banner-swiper-one-area">
        <div className="swiper mySwiper-banner-one">
          <div className="swiper-wrapper">
            {/* single swiper area start */}
            <div className="swiper-slide">
              <div className="tmp-banner-area bg_image-1 bg_image banner-one-height-control tmp-section-gap">
                <div className="shape-image-banner-one">
                  <img
                    src={require("../assets/images/banner/shape/01.png")}
                    alt="banner"
                    className="one"
                  />
                  {/* <img
                    src={require("../assets/images/banner/shape/02.png")}
                    alt="banner"
                    className="two"
                  /> */}
                  <img
                    src={require("../assets/images/banner/shape/03.png")}
                    alt="banner"
                    className="three"
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="banner-one-main-wrapper">
                        <div className="inner">
                          <span className="sub-title">
                            IT Service Provider
                          </span>
                          <h1 className="title">
                            IT consulting solution
                          </h1>
                          <p className="disc">
                            {/* We help small startups grow from idea to millions of
                            users. we can also <br></br>
                            automate your marketing and customer service. */}
                            Our work is built on the foundation of Design, AI and Data and strong engineering capabilities.
                            <br></br>We have deep domain expertise and work across multiple industries from <br></br>
                            telecom, financial services, product engineering to life sciences.
                          </p>
                          <div className="button-area-banner-one">
                            <Link to="/itconsulting" className="tmp-btn btn-primary">
                              Get Started Now
                            </Link>
                            {/* video icon */}
                            <div
                              className="vedio-icone"
                              data-tmp-cursor="lg"
                              data-tmp-cursor-text="Play Video"
                            >
                              {/* <Link
                                className="video-play-button play-video"
                                to="#"
                              >
                                <span></span>
                                <p className="text">Play Vedio</p>
                              </Link>
                              <div className="video-overlay">
                                <Link className="video-overlay-close">×</Link>
                              </div> */}
                            </div>
                            {/* video icon */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* single swiper area start */}

            {/* single swiper area start */}
            <div className="swiper-slide">
              <div className="tmp-banner-area bg_image-2 bg_image banner-one-height-control tmp-section-gap">
                <div className="shape-image-banner-one">
                  <img
                    src={require("../assets/images/banner/shape/01.png")}
                    alt="banner"
                    className="one"
                  />
                  {/* <img
                    src={require("../assets/images/banner/shape/02.png")}
                    alt="banner"
                    className="two"
                  /> */}
                  <img
                    src={require("../assets/images/banner/shape/03.png")}
                    alt="banner"
                    className="three"
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="banner-one-main-wrapper">
                        <div className="inner">
                          <span className="sub-title">
                            Exam Infra Service Provoder
                          </span>
                          <h1 className="title">
                            Online/Offline Exam Solutions
                          </h1>
                          <p className="disc">
                            We provide end-to-end Online Exam Infrastructure & Service Management solutions to ensure smooth, secure, and reliable examinations. 
                            <br></br>Our services include robust server and network setup, scalable platforms for high concurrent users, <br></br>AI-based and live proctoring, and 24/7 technical support. With advanced security measures and real-time monitoring,<br></br> we guarantee a seamless testing experience for both administrators and candidates.
                          </p>
                          <div className="button-area-banner-one">
                            <Link to="/agency" className="tmp-btn btn-primary">
                              Get Started Now
                            </Link>
                            {/* video icon */}
                            {/* <div
                              className="vedio-icone"
                              data-tmp-cursor="lg"
                              data-tmp-cursor-text="Play Video"
                            >
                              <Link
                                className="video-play-button play-video"
                                to="#"
                              >
                                <span></span>
                                <p className="text">Play Vedio</p>
                              </Link>
                              <div className="video-overlay">
                                <Link className="video-overlay-close">×</Link>
                              </div>
                            </div> */}
                            {/* video icon */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* single swiper area start */}
            
            {/* single swiper area start */}
            <div className="swiper-slide">
              <div className="tmp-banner-area bg_image-3 bg_image banner-one-height-control tmp-section-gap">
                <div className="shape-image-banner-one">
                  <img
                    src={require("../assets/images/banner/shape/01.png")}
                    alt="banner"
                    className="one"
                  />
                  {/* <img
                    src={require("../assets/images/banner/shape/02.png")}
                    alt="banner"
                    className="two"
                  /> */}
                  <img
                    src={require("../assets/images/banner/shape/03.png")}
                    alt="banner"
                    className="three"
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="banner-one-main-wrapper">
                        <div className="inner">
                          <span className="sub-title">
                            Financial & Investment Solutions
                          </span>
                          <h1 className="title">Investment Solutions</h1>
                          <p className="disc">
                            We offer comprehensive Financial & Investment Solutions tailored to help individuals and businesses grow and safeguard their wealth. 
                            <br></br>From strategic investment planning and portfolio management to tax-efficient strategies and risk assessment, 
                            <br></br>we provide expert guidance at every step. Our goal is to deliver sustainable financial growth, transparent advice, and personalized strategies that align with your unique goals
                          </p>
                          <div className="button-area-banner-one">
                            <Link to="/financial" className="tmp-btn btn-primary">
                              Get Started Now
                            </Link>
                            {/* video icon */}
                            {/* <div
                              className="vedio-icone"
                              data-tmp-cursor="lg"
                              data-tmp-cursor-text="Play Video"
                            >
                              <Link
                                className="video-play-button play-video"
                                to="#"
                              >
                                <span></span>
                                <p className="text">Play Vedio</p>
                              </Link>
                              <div className="video-overlay">
                                <Link className="video-overlay-close">×</Link>
                              </div>
                            </div> */}
                            {/* video icon */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* single swiper area start */}
          </div>
          
          <div
            className="swiper-button-prev"
            data-tmp-cursor="md transparent fw-bold"
            data-tmp-cursor-text="Prev"
          ></div>
          <div
            className="swiper-button-next"
            data-tmp-cursor="md transparent fw-bold"
            data-tmp-cursor-text="Next"
          ></div>
        </div>
      </div>
      {/* tmp banner area end */}
        </>
    )


}


export default Carousal;    


